import { FinPlansApi } from '@servicetitan/financing-api-client';
import { useDependencies } from '@servicetitan/react-ioc';
import { useQuery } from '@tanstack/react-query';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { SelectField } from '@servicetitan/anvil2-react-hook-form';
import { CSSProperties } from 'react';

interface ImprovementTypeComboboxProps {
    style?: CSSProperties;
    required?: boolean;
    disabled?: boolean;
    gridColumn?: string;
}

export const ImprovementTypeCombobox = ({
    style,
    required = true,
    disabled = false,
    gridColumn,
}: ImprovementTypeComboboxProps = {}) => {
    const [apiClient] = useDependencies(FinPlansApi);
    const { setupData } = SetupDataStore.useStore();

    const { data } = useQuery({
        queryKey: ['improvementTypes'],
        queryFn: () =>
            apiClient.improvementsGetSelectedImprovements({
                providerName: setupData?.provider ?? '',
                tenantId: setupData?.tenantId ?? null,
            }),
        enabled: setupData?.provider != null,
    });

    const options = (data?.data.improvements ?? []).map(improvement => ({
        id: improvement,
        label: improvement,
    }));

    return data != null ? (
        <SelectField
            name="improvement"
            options={options}
            label="Improvement Type"
            required={required}
            disabled={disabled}
            style={style}
            gridColumn={gridColumn}
        />
    ) : null;
};
